function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FrenchSouthernAndAntarcticLandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M14.092 7.65h6.036l-.588 1.128h-1.831v.606h1.403l-.571 1.05h-.832v2.098l1.37-2.16 1.773 3.072h-.724l-.253-.337H18.27l-1.13 2.086.001.115-.031-.058-.032.058v-.115l-1.128-2.086h-1.605l-.253.337h-.725l1.774-3.071 1.37 2.159V8.778H14.68l-.588-1.128Zm5.022 3.982-.394.606h.746l-.352-.606Zm-4.009 0 .394.606h-.745l.351-.606Zm-2.87-.672.623-.46.624.46-.22-.77.605-.486-.76-.017-.248-.76-.25.76-.759.017.605.486-.22.77Zm9.107-.46-.624.46.22-.77-.605-.486.76-.017.248-.76.25.76.759.017-.605.486.22.77-.623-.46Zm-2.532 5.852.623-.459.623.46-.22-.77.605-.487-.759-.016-.25-.76-.248.76-.76.016.605.486-.22.77Zm-4.043-.459-.623.46.22-.77-.605-.487.759-.016.25-.76.248.76.76.016-.605.486.22.77-.624-.459Zm1.71 2.257.623-.46.623.46-.22-.77.605-.486-.759-.016-.249-.76-.25.76-.759.016.606.486-.22.77Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#2E42A5",
        stroke: "#fff",
        strokeWidth: ".5",
        d: "M-.25 2.75h9.5v8h-9.5z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "11",
        height: "9",
        x: "-1",
        y: "2",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".5",
          d: "M-.25 2.75h9.5v8h-9.5z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "M6 3h3v7.5H6V3Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#2E42A5",
          d: "M0 3h3v7.5H0V3Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "M3 3h3v7.5H3V3Z"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=FrenchSouthernAndAntarcticLands.js.map